import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';

// Translation
import { FormattedMessage, useIntl } from 'react-intl';

import DocumentUpload from '../../components/DocumentUpload';
import DashboardSideMenu from '../../components/Dashboard/DashboardSideMenu';

// Locale
import messages from '../../locale/jsonMessages';

import s from './DocumentVerification.css';
import cs from '../../components/commonStyle.css';

const DocumentVerification = () => {

  const { formatMessage } = useIntl();

  return (
    <Grid fluid className={'listingContainer'}>
      <Row>
        <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
          <DashboardSideMenu isTrustVerfiedPage />
        </Col>
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
          <div className={'youcarsBg'}>
            <h3 className={s.infoTitle}>
              <FormattedMessage {...messages.documentVerification} />
            </h3>
            <DocumentUpload placeholder={formatMessage(messages.documentUploadPlaceholder)} />
          </div>
        </Col>
      </Row>
    </Grid>
  );
}

DocumentVerification.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s, cs)(DocumentVerification);
